var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 8.83325C2.46026 8.83325 2.83335 8.46016 2.83335 7.99992C2.83335 7.53968 2.46026 7.16659 2.00002 7.16659C1.53978 7.16659 1.16669 7.53968 1.16669 7.99992C1.16669 8.46016 1.53978 8.83325 2.00002 8.83325Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 2.99992C2.46026 2.99992 2.83335 2.62682 2.83335 2.16659C2.83335 1.70635 2.46026 1.33325 2.00002 1.33325C1.53978 1.33325 1.16669 1.70635 1.16669 2.16659C1.16669 2.62682 1.53978 2.99992 2.00002 2.99992Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 14.6666C2.46026 14.6666 2.83335 14.2935 2.83335 13.8333C2.83335 13.373 2.46026 12.9999 2.00002 12.9999C1.53978 12.9999 1.16669 13.373 1.16669 13.8333C1.16669 14.2935 1.53978 14.6666 2.00002 14.6666Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.ceb215e2247bfb509bf7781d6b04046b.svg";
export { ForwardRef as ReactComponent };